module.exports = __webpack_public_path__ + "img/agriculture_1.0425553b.jpg";